import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconLabelComponent } from "./med-icon-label.component";

@NgModule({
  declarations: [
    MedIconLabelComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconLabelComponent,
  ],
})
export class MedIconLabelModule { }
